t = require('views/internal/teacup-with-helpers')('org_slack_restrictions')

module.exports = t.renderable (data) ->
  { adminOnly } = data

  t.div { style: 'margin: 12px 0 0;' }, ->

    t.p ->
      t.format 'who-can-link-slack-teams'

    t.ul '.pop-over-list.checkable.left-check.normal-weight', ->

      t.li { class: t.classify('active': !adminOnly, 'js-disable-admin-only': true) }, ->
        t.a { href: '#' }, ->
          t.format 'any-team-member'
          t.span '.icon-sm.icon-check'

      t.li { class: t.classify('active': adminOnly, 'js-enable-admin-only': true) }, ->
        t.a { href: '#' }, ->
          t.format 'only-team-admins'
          t.span '.icon-sm.icon-check'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_slack_restrictions.coffee